import styled from 'styled-components';
import { AMBER_400, BLACK, GRAYSCALE_400, GRAYSCALE_500, GREEN_600, NEUTRAL_100, WHITE } from "@styles/colors";
import { INTER } from "@styles/fonts";
import { safeAreaInset } from '@lib/telegram';

// Main container styles
export const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  z-index: 1;
  position: relative;
`;

export const HeaderContainer = styled.div`
  z-index: 3;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
`;

export const HeaderBackground = styled.img`
  width: 100%;
  height: 30%;
  position: fixed;
  top: 0;
  z-index: 2;
`;

export const Body = styled.div`
  z-index: 3;
  display: flex;
  flex-direction: column;
  padding: 20% 12px 160px 12px;
  margin-top: 60px;
`;

export const ButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  z-index: 3;
  background-color: ${WHITE};
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

// Receipt Card Row Value styles
export const StatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  max-width: 50%;
`;

export const StatusText = styled.span<{ $isCompleted: boolean }>`
  color: ${props => props.$isCompleted ? GREEN_600 : AMBER_400};
  font-family: ${INTER.bold};
  font-size: 14px;
`;

export const CurrencyText = styled.span<{ $boldValue?: boolean }>`
  color: ${BLACK};
  font-family: ${props => props.$boldValue ? INTER.bold : INTER.regular};
  font-size: 14px;
  text-align: right;
  word-break: break-all;
  max-width: 80%;
`;

export const TextValue = styled.span<{ $boldValue?: boolean }>`
  color: ${BLACK};
  font-family: ${props => props.$boldValue ? INTER.bold : INTER.regular};
  font-size: 14px;
  text-align: right;
  word-break: break-all;
  max-width: 60%;
`;

export const TimestampText = styled.span<{ $boldValue?: boolean }>`
  color: ${BLACK};
  font-family: ${props => props.$boldValue ? INTER.bold : INTER.regular};
  font-size: 14px;
  text-align: right;
  word-break: break-all;
  max-width: 60%;
`;

// Receipt Card Row styles
export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 8px;
`;

export const RowLabel = styled.span`
  color: ${GRAYSCALE_500};
  font-family: ${INTER.regular};
  font-size: 14px;
  max-width: 50%;
`;

// Receipt Card styles
export const Card = styled.div`
  position: relative;
  padding: 32px 12px 16px 12px;
  background-color: ${WHITE};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
`;

export const CardContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${NEUTRAL_100};
  margin: 16px 0;
`;

export const PendingMessage = styled.span`
  color: ${GRAYSCALE_500};
  font-size: 13px;
  font-family: ${INTER.regular};
  text-align: center;
`;

// Receipt Amount styles
export const AmountContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  color: ${BLACK};
`;

export const AmountLabel = styled.span`
  color: ${GRAYSCALE_400};
  font-family: ${INTER.regular};
  font-size: 13px;
`;

export const AmountValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-family: ${INTER.bold};
  font-size: 26px;
`;

// Big Status Icon styles
export const StatusIconContainer = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -70px;
  left: 50%;
  transform: translateX(-50%);
`;

// Pull-to-refresh indicator styles
export const RefreshIndicatorContainer = styled.div`
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 1000;
`;

// Button row container styles
export const ButtonRowContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
`;
